<template>
  <footer class="footer footer-static footer-light">
    <p class="clearfix text-muted text-center pt-2 pb-1">
      <span>
        {{ $t("labels.madeBy") }}
        <a
          href="https://www.devinterface.com"
          id="pixinventLink"
          target="_blank"
          class="text-bold-800 primary darken-2 ml-2"
        >
        <img src="/app-assets/img/logo-devinterface.png" width="200"/>
        </a>
      </span>
    </p>
  </footer>
</template>
<script>
export default {
  methods: {
    getYear: function() {
      const date = new Date();
      return date.getFullYear();
    }
  }
};
</script>